module.exports = __webpack_public_path__ + "06e163d0e53cb3f5ba4485715ec0b058.MP3";